<template>
  <div class="pts-news">
    <div class="pts-container">
      <h1>{{ $t('who', 'Qui sommes-nous ?') }}</h1>
      <div class="pts-news__container">
        <div class="pts-news__left">
          <div class="pts-news__tiles">
            <pts-tile icon="trending_up">
              {{ $t('transport', 'Transporteur professionnel depuis 2009') }}
            </pts-tile>
            <pts-tile icon="directions_car">
              {{ $t('choice', 'Large choix de véhicules de qualité') }}
            </pts-tile>
            <pts-tile icon="streetview">
              {{ $t('region', 'Parfaite connaissance de la région Ile de France') }}
            </pts-tile>
            <pts-tile icon="euro_symbol">
              {{ $t('price', 'Des forfaits adaptés à chacun de vos besoins') }}
            </pts-tile>
          </div>
        </div>
        <div class="pts-news__right">
          <div id="fb-root"></div>
          <div class="fb-page" data-href="https://www.facebook.com/Premium-Transport-Services-200865789939479/" data-tabs="timeline" data-width="400" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/Premium-Transport-Services-200865789939479/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/Premium-Transport-Services-200865789939479/">Premium Transport Services</a></blockquote></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tile from './Tile.vue'

export default {
  name: 'News',
  components: {
    'pts-tile': Tile
  },
  mounted() {
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v2.12';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'))

    this.$polyglot.extendLocales({
      'fr': {
        'who': 'Qui sommes-nous ?',
        'transport': 'Transporteur professionnel depuis 2009',
        'choice': 'Large choix de véhicules de qualité',
        'region': 'Parfaite connaissance de la région Ile de France',
        'price': 'Des forfaits adaptés à chacun de vos besoins'
      },
      'en': {
        'who': 'Who are we ?',
        'transport': 'Professional transporter since 2009',
        'choice': 'Wide choice of quality vehicles',
        'region': 'Perfect knowledge of the Ile de France region',
        'price': 'Packages designed to all your needs'
      }
    })
  }
}
</script>

<style scoped>
.pts-news {
  width: 100%;
  background: #F5F5F5;
  padding-top: 100px;
  border-bottom: 1px solid #B3B3B3;
}

.pts-news .pts-news__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.pts-news .pts-news__left {
  max-width: 500px;
  text-align: justify;
  padding: 0 10px;
}

.pts-news .pts-news__left .pts-news__tiles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.pts-news .pts-news__right {
  width: 400px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue